export default __webpack_public_path__ + "static/media/logo_pnj.42902c2a.png";